import axios from "axios";

let baseURL = "https://delistumerienda.cloud/api";

if (window.location.hostname === "localhost") {
  baseURL = "http://localhost:8080/api";
} else if (window.location.hostname.startsWith("172.")) {
  baseURL = "http://172.16.15.59:8080/api";
}

const api = axios.create({ baseURL });

/* ===============================
   REQUEST
================================ */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // 🔓 ENDPOINTS PÚBLICOS
    if (
      config.url?.startsWith("/public") ||
      config.url?.startsWith("/auth")
    ) {
      return config;
    }

    // 🔐 ENDPOINTS PROTEGIDOS
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ===============================
   RESPONSE
================================ */
let logoutTriggered = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url;

    // 🔓 NO cerrar sesión si es endpoint público
    if (
      (status === 401 || status === 403) &&
      !url?.startsWith("/public") &&
      !logoutTriggered
    ) {
      logoutTriggered = true;

      console.warn("🔐 Sesión expirada → logout global");
      window.dispatchEvent(new Event("logout"));
    }

    return Promise.reject(error);
  }
);

export default api;
